<template>
  <div class="card">
    <header class="header-card">
      <p> {{ $t('editionCommande.logistiqueImpression.affiches.title')}} </p>
    </header>
    <div class="card-content">
      <div class="level">
        <div class="level-left">
          <div class="columns">
            <selecteur-action
              @handleAction="handleAction"
              :options="actions"
              :placeholder="$t('general.placeHolder.groupedAction')"
              :elementsSelectionnes="getAllSelected.length > 0"
              titleButton="general.button.apply"
              class="column is-narrow">
            </selecteur-action>
            <div class="column is-narrow">
              <button class="button" @click="setShowFiltre">
                <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
                <span class="is-size-7">
                  {{$t('general.button.filtre')}}
                  <label
                    class="has-text-weight-bold"
                    :class="nombreCritere > 0 ? '' : 'is-invisible'">
                    ({{ nombreCritere }})
                  </label>
                </span>
              </button>
              <span
                @click="reinitialiserFiltre()"
                class="info-circle-right is-pulled-right is-cursor-pointer">
                <b-icon icon="close-circle" type="is-danger"></b-icon>
              </span>
            </div>
          </div>
        </div>
        <div class="columns level-right">
          <div class="column">
            <qd-button
              :disabled="hasBesoinInCreated"
              class="button is-primary"
              @click="ajouterBesoin">
              {{ $t('editionCommande.logistiqueImpression.affiches.addBesoin') }}
            </qd-button>
          </div>
        </div>
      </div>
      <v-server-table
        v-if="mountedLoadingEnd"
        url=""
        :columns="columns"
        :options="options"
        :ref="constantes.REFERENCE_TABLE_AFFICHES"
        @loading="debutLoading"
        @loaded="finLoading"
        class="pdb-250px overflow-x-auto">
        <template #selected="{ row }">
          <div class="has-text-centered">
            <b-checkbox
              v-model="row.selected"
              :disabled="hasBesoinInCreated">
            </b-checkbox>
          </div>
        </template>
        <template
          v-for="column in columnsEditable"
          #[column]="{ row, index }">
          <besoin-input
            :key="`${row.key}-${column}`"
            :value="row"
            :field="column"
            :besoins="besoinsSync"
            :index="index"
            :commande="commande"
            :id="`besoinInput${index}${column}`"
            @update-besoin="updateBesoin($event, index)" />
        </template>
        <template #anneeSemaineDepart="{ row }">
          <div class="is-pulled-right">
            {{ getSemaine(row.anneeSemaineDepart) }}
          </div>
        </template>
        <template #nbAfficheTotal="{ row }" >
          <div class="is-pulled-right">
            {{ row.nbAfficheTotal }}
          </div>
        </template>
        <template #etat="{ row }" >
          {{ $t(getLibelleEtat(row.etat)) }}
        </template>
        <template #commandeAchat="{ row }">
          <div v-if="row.commandeAchat">
            <router-link-blank
              :to="{ name: 'c.achat.commandes', params: { id: row.commandeAchatId } }"
              :message="row.commandeAchat.code">
            </router-link-blank>
            <div>
              ({{ getEtatCommande(row) }})
            </div>
          </div>
        </template>
        <template #print="{ row }">
          <div class="has-text-centered">
            <btn-action-icon
              :permission="perm.maj"
              :tooltipLabel="$t('general.button.edition')"
              :disabled="!row.commandeAchatId"
              @is-click="inProgress()"
              icon="file-pdf-box">
            </btn-action-icon>
          </div>
        </template>
        <template #decommander="{ row }">
          <div class="has-text-centered">
            <btn-action-icon
              :disabled="!row.commandeAchatId"
              :permission="perm.maj"
              :tooltipLabel="
                $t('editionCommande.logistiqueImpression.affiches.decommander')"
              @is-click="openPopUpSansSuite(row.commandeAchatId)"
              icon="text-box-remove"
              icon-type="is-default">
            </btn-action-icon>
          </div>
        </template>
        <template #commander="{ row }">
          <div class="has-text-centered">
            <btn-action-icon
              v-if="!row.id"
              :permission="perm.maj"
              :tooltipLabel="$t('general.button.save')"
              @is-click="createBesoin(row)"
              icon="content-save"
              icon-type="is-primary">
            </btn-action-icon>
            <btn-action-icon
              v-else
              :permission="perm.maj"
              :tooltipLabel="
                $t('editionCommande.logistiqueImpression.affiches.genererCommandeAchat')"
              :disabled="hasBesoinInCreated || !!row.commandeAchatId || !row.id"
              @is-click="handleAction(constantes.ACTION_GENERATION_COMMANDE_ACHAT, row)"
              icon="text-box-plus"
              icon-type="is-default">
            </btn-action-icon>
          </div>
        </template>
        <template #dupliquer="{ row }">
          <div class="has-text-centered">
            <btn-action-icon
              :permission="perm.maj"
              :tooltipLabel="$t('general.button.dupliquer')"
              :disabled="hasBesoinInCreated"
              @is-click="handleAction(constantes.ACTION_DUPLICATION, row)"
              icon="file-multiple"
              icon-type="is-default">
            </btn-action-icon>
          </div>
        </template>
        <template #delete="{ row }">
          <div class="has-text-centered">
            <btn-action-icon
              :tooltipPosition="'is-left'"
              :tooltipLabel="!!func.besoinIsNotDeletableMsg(row)
                ? func.besoinIsNotDeletableMsg(row) : $t('general.button.delete')"
              :permission="perm.supprimer"
              :disabled="(hasBesoinInCreated && !!row.id) || !!func.besoinIsNotDeletableMsg(row)"
              @is-click="handleAction(constantes.ACTION_DELETE, row)"
              icon-type="is-danger"
              icon="delete-forever">
            </btn-action-icon>
          </div>
        </template>
        <template #appendBody>
          <table-footer-totaux
            :columns="columns"
            :target="columsTotaux"
            :items="besoinsSync"
            :formatage="(val) => val">
          </table-footer-totaux>
        </template>
      </v-server-table>
      <transition
        name="custom-classes-transition"
        enter-active-class="animate__animated animate__slideInRight"
        leave-active-class="animate__animated animate__slideOutRight"
        :duration="10">
        <div v-show="showFiltre" class="componentBrief">
          <filtre-liste
            @toggleFiltre="setShowFiltre"
            @recherche="makeRechercheFilter"
            :name-store="nameStore"
            ref="filtreListe" />
        </div>
      </transition>
    </div>
    <b-modal
      v-model="popUpPrevention"
      @close="closePopUpPrevention"
      has-modal-card
      class="modal">
      <pop-up-prevention
        :mess-header="msgPopUpPrevention.header"
        :mess-description="msgPopUpPrevention.description"
        :messages-popup="messagesErreurPopUp"
        :is-error-popup.sync="errorPopUp"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="closePopUpPrevention"
        @yes="actionYesPopUpPreventionAsync"/>
    </b-modal>
    <b-modal
      v-model="popUpUpdateBesoin"
      @close="popUpUpdateBesoin = false"
      has-modal-card
      class="modal">
      <pop-up-update-besoin
        :besoin-ids="besoinIds"
        :tiersInIntervenantsCommande="tiersInIntervenantsCommande"
        @updateDone="recherche()"/>
    </b-modal>
    <b-modal v-model="popUpSansSuite" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="$t('detailCommandeAchatFournisseur.sansSuiteTitle')"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        :isErrorPopup.sync="isErrorPopup"
        :messagesPopup="messagesPopup"
        @no="popUpSansSuite = false"
        @yes="sansSuiteCommande()">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { sansSuite } from '@/api/commandeAchat';
import {
  createAll,
  updateAll,
  deleteAll,
  duplicateAll,
  genererCommandeAchatAll,
} from '@/api/besoin';
import cloneDeep from 'lodash/cloneDeep';
import * as tableConfig from '@/configuration/clientTableConf';
import * as devisConf from '@/configuration/devisConf';
import { SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import { SET_ADD_ITEM, SET_ITEMS } from '@/store/modules/bodac/besoin/besoin-mutation-type';
import { REFERENCE_TABLE_AFFICHES } from '@/configuration/general/referenceTableConf';
import { BESOIN } from '@/configuration/permissionsBodacConf';
import { ACTION_DELETE, ACTION_DUPLICATION } from '@/configuration/general/actionsConf';
import {
  ACTION_GENERATION_COMMANDE_ACHAT,
  ACTION_EDIT_BESOIN,
  TYPE_IMPRESSION,
  ETATS_BESOIN,
} from '@/configuration/bodac/besoin/besoinConfig';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import formatDate from '@/services/general/formatDate';
import formatIsoDate from '@/services/general/formatIsoDate';
import validation from '@/services/bodac/besoin/validation';
import validationCommandeAchat from '@/services/achat/commandes/validationCommandeAchat';
import genererBesoin from '@/services/bodac/besoin/genererBesoin';
import { besoinIsNotDeletableMsg } from '@/services/bodac/besoin/besoinService';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import tagInputToArray from '@/services/general/filters/tagInputToArray';
import inProgress from '@/services/general/inProgress';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/bodac/besoin/translator';
import FiltreListe from '@/components/commande/logistiqueImpression/stepImpression/filtreListeBesoin';
import SelecteurAction from '@/components/general/selecteurAction';
import RouterLinkBlank from '@/components/general/routerLinkBlank';
import PopUpPrevention from '@/components/general/popUpPrevention';
import TableFooterTotaux from '@/components/general/tableFooterTotaux';
import BtnActionIcon from '@/components/general/btnActionIcon';
import PopUpUpdateBesoin from '@/components/commande/logistiqueImpression/stepImpression/popupUpdateBesoinInfos';
import BesoinInput from '@/components/commande/logistiqueImpression/stepImpression/besoinInput';

const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'AffichesCard',
  props: {
    commande: {
      type: Object,
      required: true,
    },
    nameStore: {
      type: String,
      required: true,
    },
  },
  components: {
    FiltreListe,
    SelecteurAction,
    RouterLinkBlank,
    PopUpPrevention,
    TableFooterTotaux,
    PopUpUpdateBesoin,
    BtnActionIcon,
    BesoinInput,
  },
  data() {
    return {
      msgPopUpPrevention: {
        header: '',
        description: '',
      },
      actionYesPopUpPrevention: null,
      messagesErreurPopUp: [],
      errorPopUp: false,
      popUpPrevention: false,
      showFiltre: false,
      refresh: false,
      loadingComponent: null,
      perm: BESOIN,
      func: {
        formatDate,
        besoinIsNotDeletableMsg,
      },
      constantes: {
        ACTION_DELETE,
        ACTION_DUPLICATION,
        ACTION_GENERATION_COMMANDE_ACHAT,
        REFERENCE_TABLE_AFFICHES,
      },
      actions: [
        { action: ACTION_GENERATION_COMMANDE_ACHAT, translation: 'editionCommande.logistiqueImpression.affiches.genererCommandeAchat' },
        { action: ACTION_DUPLICATION, translation: 'general.button.dupliquer' },
        { action: ACTION_EDIT_BESOIN, translation: 'editionCommande.logistiqueImpression.affiches.editerBesoinEnMasse' },
        { action: ACTION_DELETE, translation: 'general.button.delete' },
      ],
      popUpUpdateBesoin: false,
      besoinIds: null,
      commandeAchatId: null,
      popUpSansSuite: false,
      isErrorPopup: false,
      messagesPopup: [],
      mountedLoadingEnd: false,
    };
  },
  computed: {
    ...Societe.mapGetters({
      lockMenu: 'lockMenu',
    }),
    besoinsSync: {
      get() {
        return this.$store.getters[`${this.nameStore}/items`];
      },
      set(value) {
        this.$store.commit(`${this.nameStore}/${SET_ITEMS}`, value);
      },
    },
    besoinsTotalCount() {
      return this.$store.getters[`${this.nameStore}/totalCount`];
    },
    critereRecherche() {
      return this.$store.getters[`${this.nameStore}/criteresRecherche`];
    },
    tiersInIntervenantsCommande() {
      return this.commande.intervenants.filter(i => i.tiersId).map(i => i.tiers);
    },
    getAllSelected() {
      return this.besoinsSync.filter(b => b.selected);
    },
    nombreCritere() {
      const banCritereKey = ['dateLivraison', 'commande'];
      let nbCritere = calculNombreCritere(this.critereRecherche, banCritereKey);
      if (this.critereRecherche.dateLivraison.dateDebut
       || this.critereRecherche.dateLivraison.dateFin) {
        nbCritere += 1;
      }
      nbCritere += this.critereRecherche.commande !== null ? 1 : 0;
      return nbCritere <= 9 ? nbCritere : '+9';
    },
    allIsSelected() {
      return this.besoinsSync.every(b => b.selected);
    },
    iconSelectTotal() {
      if (this.allIsSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    columnsData() {
      return [
        { name: 'selected' },
        { name: 'produitAchat', sortable: true, editable: true },
        { name: 'formatAffiche', sortable: true, editable: true },
        { name: 'natureSupportAfficheId', sortable: true, editable: true },
        { name: 'typeMaterielId', sortable: true, editable: true },
        { name: 'largeur', sortable: true, editable: true },
        { name: 'longueur', sortable: true, editable: true },
        { name: 'produit', sortable: true, editable: true },
        { name: 'anneeSemaineDepart', sortable: true },
        { name: 'dateDepart', sortable: true, editable: true },
        { name: 'etat', sortable: true },
        { name: 'visuel', sortable: false, editable: true },
        {
          name: 'nbAfficheVendue',
          sortable: true,
          totaux: true,
          editable: true,
        },
        {
          name: 'nbAfficheMaintenance',
          sortable: true,
          totaux: true,
          editable: true,
        },
        { name: 'nbAfficheTotal', sortable: true, totaux: true },
        { name: 'commentaire', sortable: true, editable: true },
        { name: 'tiersDestinataire', sortable: true, editable: true },
        { name: 'lieuLivraisonPrestation', sortable: true, editable: true },
        { name: 'dateLivraison', sortable: true, editable: true },
        { name: 'commandeAchat', sortable: true },
        { name: 'print' },
        { name: 'commander' },
        { name: 'decommander' },
        { name: 'dupliquer' },
        { name: 'delete' },
      ];
    },
    columsTotaux() {
      return this.columnsData.filter(c => c.totaux).map(c => c.name);
    },
    columns() {
      return this.columnsData.map((column) => column.name);
    },
    columnsEditable() {
      return this.columnsData.filter(c => c.editable).map(c => c.name);
    },
    options() {
      const texts = cloneDeep(tableConfig.TEXTS);
      texts.count = '';
      const selectedFunc = (h) => {
        return h(
          'a', {
            attrs: { class: 'pointer' },
            on: {
              click: () => {
                if (this.hasBesoinInCreated) return;
                const allSelected = this.allIsSelected;
                this.besoinsSync.forEach(c => {
                  c.selected = !allSelected;
                });
              },
            },
          },
          [
            h('b-icon', {
              attrs: { icon: this.iconSelectTotal },
            }),
          ],
        );
      };
      const headings = this.columnsData.reduce((acc, column) => {
        const field = column.trad || column.name;
        const key = `editionCommande.logistiqueImpression.affiches.table.${field}`;
        if (column.name === 'selected') {
          acc[column.name] = selectedFunc;
        } else {
          acc[column.name] = this.$te(key) ? this.$t(key) : '';
        }
        return acc;
      }, {});
      return {
        texts,
        headings,
        sortable: this.hasBesoinInCreated ? []
          : this.columnsData.filter((c) => c.sortable).map((c) => c.name),
        filterable: false,
        sortIcon: tableConfig.SORT_ICON,
        perPageValues: tableConfig.NO_PER_PAGE_VALUE,
        perPage: tableConfig.RESULTS_PER_PAGE,
        editableColumns: ['selected'],
        uniqueKey: 'key',
        columnsClasses: {
          selected: 'colonneSelected',
          produitAchat: 'w-min-max-180px',
          formatAffiche: 'w-min-max-150px',
          natureSupportAfficheId: 'w-min-max-180px',
          typeMaterielId: 'w-min-max-150px',
          largeur: 'w-min-max-120px',
          longueur: 'w-min-max-120px',
          produit: 'w-min-max-130px',
          anneeSemaineDepart: 'w-min-max-120px',
          dateDepart: 'w-min-max-120px',
          nbAfficheVendue: 'w-min-max-110px',
          nbAfficheMaintenance: 'w-min-max-100px',
          nbAfficheTotal: 'w-min-max-110px',
          commentaire: 'w-min-max-150px',
          tiersDestinataire: 'w-min-max-150px',
          lieuLivraisonPrestation: 'w-min-max-150px',
          dateLivraison: 'w-min-max-150px',
          commandeAchat: 'w-min-max-150px',
          print: 'colonneSelected-35',
          decommander: 'colonneSelected-35',
          commander: 'colonneSelected-35',
          dupliquer: 'colonneSelected-35',
          delete: 'colonneSelected-35',
        },
        rowClassCallback: () => 'is-relative',
        rowAttributesCallback: (row) => ({ id: row.key }),
        cellClasses: {
          ...this.columnsEditable.reduce((acc, c) => ({
            ...acc,
            [c]: [{ condition: () => true, class: 'pd-0 is-relative height-60' }],
          }), {}),
        },
        requestFunction: ((data) => {
          data.query = cloneDeep(this.critereRecherche);
          data.query.commandeId = this.commande.id;
          data.query.typeBesoin = TYPE_IMPRESSION;
          data.query.produitAchatIds = tagInputToArray(data.query.produitAchatIds, 'id');
          data.query.formatAfficheIds = tagInputToArray(data.query.formatAfficheIds, 'id');
          data.query.natureSupportAfficheIds = tagInputToArray(data.query.natureSupportAfficheIds, 'id');
          data.query.typeMaterielIds = tagInputToArray(data.query.typeMaterielIds, 'id');
          data.query.tiersDestinataireIds = tagInputToArray(data.query.tiersDestinataireIds, 'id');
          data.query.lieuLivraisonPrestationIds = tagInputToArray(data.query.lieuLivraisonPrestationIds, 'id');
          data.query.dateLivraison.dateDebut = formatIsoDate(data.query.dateLivraison.dateDebut);
          data.query.dateLivraison.dateFin = formatIsoDate(data.query.dateLivraison.dateFin);
          return this.actionLoadBesoins(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.besoinsSync,
            count: this.besoinsTotalCount,
          };
        }),
      };
    },
    hasBesoinInCreated() {
      return this.besoinsSync.some(b => !b.id);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    inProgress() {
      inProgress(this.$i18n);
    },
    actionLoadBesoins(payload) {
      return this.$store.dispatch(`${this.nameStore}/load`, payload);
    },
    recherche() {
      this.$refs[REFERENCE_TABLE_AFFICHES].refresh();
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListe.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    reinitialiserFiltre() {
      this.$refs.filtreListe.viderCritere();
      this.$refs.filtreListe.initializeFiltre();
      this.$refs.filtreListe.appliquerCritere();
      this.showFiltre = false;
    },
    finLoading() {
      this.loadingComponent.close();
      if (this.refresh) this.$emit('refresh');
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    getLibelleEtat(etat) {
      return ETATS_BESOIN.find(e => e.code === etat)?.libelle;
    },
    getEtatCommande(row) {
      if (!row.commandeAchat) return '';
      const { etat } = row.commandeAchat;
      let etatTrad = '';
      if (etat === devisConf.ETAT_ENREGISTRE) {
        etatTrad = this.$t('editionCommande.logistiqueImpression.etat.commande');
      } else {
        const find = devisConf.COMMANDE_ACHAT_FOURNISSEUR_ETAT.find((el) => el.code === etat);
        etatTrad = find ? this.$t(find.libelle) : '';
      }
      return etatTrad;
    },
    openPopUpPrevention({ header, description, actionYes }, refresh = false) {
      this.msgPopUpPrevention.header = header;
      this.msgPopUpPrevention.description = description;
      this.actionYesPopUpPrevention = actionYes;
      this.popUpPrevention = true;
      this.refresh = refresh;
    },
    closePopUpPrevention() {
      this.msgPopUpPrevention.header = '';
      this.msgPopUpPrevention.description = '';
      this.actionYesPopUpPrevention = null;
      this.popUpPrevention = false;
      this.messagesErreurPopUp = [];
      this.errorPopUp = false;
    },
    async actionYesPopUpPreventionAsync() {
      this.messagesErreurPopUp = [];
      this.errorPopUp = false;
      this.debutLoading();
      try {
        await this.actionYesPopUpPrevention();
        this.closePopUpPrevention();
        this.recherche();
      } catch (error) {
        if (error?.response?.data?.error) {
          validation(error.response, this.messagesErreurPopUp);
          this.errorPopUp = true;
          throw error;
        }
        messageErreur(this.$i18n);
        throw error;
      } finally {
        this.finLoading();
      }
    },
    ajouterBesoin() {
      this.besoinsSync.forEach(b => {
        b.selected = false;
      });
      const besoin = genererBesoin(TYPE_IMPRESSION, this.commande);
      this.$store.commit(`${this.nameStore}/${SET_ADD_ITEM}`, besoin);
    },
    async deleteAllFunc({ ids }) {
      if (!ids.length) return;
      await deleteAll({ ids });
    },
    handleAction(type, besoin) {
      const besoinsCopy = besoin ? [besoin] : this.getAllSelected;
      const ids = besoinsCopy.filter(b => b.id).map(b => b.id);
      const keys = besoinsCopy.filter(b => !b.id).map(b => b.key);
      switch (type) {
        case ACTION_DELETE:
          this.openPopUpPrevention({
            header: this.$t('editionCommande.logistiqueImpression.affiches.deleteAllPopUpHeader'),
            description: this.$t('editionCommande.logistiqueImpression.affiches.deleteAllPopUpDescription'),
            actionYes: () => this.deleteAllFunc({ ids, keys }),
          }, true);
          break;
        case ACTION_DUPLICATION:
          this.openPopUpPrevention({
            header: this.$t('editionCommande.logistiqueImpression.affiches.duplicateAllPopUpHeader'),
            description: this.$t('editionCommande.logistiqueImpression.affiches.duplicateAllPopUpDescription'),
            actionYes: () => duplicateAll({ ids }),
          });
          break;
        case ACTION_GENERATION_COMMANDE_ACHAT:
          this.openPopUpPrevention({
            header: this.$t('editionCommande.logistiqueImpression.affiches.generateAllPopUpHeader'),
            description: this.$t('editionCommande.logistiqueImpression.affiches.generateAllPopUpDescription'),
            actionYes: () => genererCommandeAchatAll({ ids }),
          });
          break;
        case ACTION_EDIT_BESOIN:
          this.besoinIds = ids;
          this.popUpUpdateBesoin = true;
          break;
        default:
          messageErreur(this.$i18n, this.$i18n.t('general.noActionSelect'));
          break;
      }
    },
    getSemaine(anneeSemaine) {
      if (!anneeSemaine) return '';
      return `S${anneeSemaine.toString().substring(4, 6)}`;
    },
    async updateBesoin(besoin, index) {
      const element = document.getElementById(besoin.key);
      const loading = this.$buefy.loading.open({ container: element });
      try {
        await updateAll([{
          ...besoin,
          dateDepart: formatIsoDate(besoin.dateDepart),
          dateLivraison: formatIsoDate(besoin.dateLivraison),
        }]);
        this.recherche();
      } catch (e) {
        let msg = '';
        if (e.response?.data?.error?.validationErrors) {
          const messages = [];
          validationGeneral(this.$i18n, e.response, [], messages, [], translate);
          if (messages.length) msg = this.$t(messages[0].message, messages[0].parametres);
        }
        messageErreur(this.$i18n, msg);
        throw e;
      } finally {
        this.$set(this.besoinsSync[index - 1], 'fieldHasModified', null);
        loading.close();
      }
    },
    async createBesoin(besoin) {
      const element = document.getElementById(besoin.key);
      const loading = this.$buefy.loading.open({ container: element });
      try {
        await createAll([{
          ...besoin,
          dateDepart: formatIsoDate(besoin.dateDepart),
          dateLivraison: formatIsoDate(besoin.dateLivraison),
        }]);
        this.recherche();
      } catch (error) {
        messageErreur(this.$i18n);
        throw error;
      } finally {
        loading.close();
      }
    },
    openPopUpSansSuite(commandeAchatId) {
      this.commandeAchatId = commandeAchatId;
      this.isErrorPopup = false;
      this.messagesPopup = [];
      this.popUpSansSuite = true;
    },
    async sansSuiteCommande() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await sansSuite(this.commandeAchatId);
        this.popUpSansSuite = false;
        this.recherche();
      } catch (e) {
        this.isErrorPopup = true;
        if (e.response?.data?.error) {
          this.messagesPopup = [''];
          validationCommandeAchat(e.response, this.messagesPopup);
          return;
        }
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      // pour eviter plusieurs chargements lors de l'affichage de besoinInput
      await this.loadParametres([
        PARAMETRES_KEYS.materielType,
        PARAMETRES_KEYS.natureSupportAffiche,
      ]);
    } finally {
      loadingComponent.close();
      this.mountedLoadingEnd = true;
    }
  },
  beforeDestroy() {
    if (this.lockMenu) this.setLockMenu(false);
  },
};

</script>
